// extracted by mini-css-extract-plugin
export default {"innerWrapper":"dA-z","tooltipWrapper":"eA-z","icon":"fA-z","tooltip":"gA-z","content":"hA-z"};